import React from 'react';
import { confirmResetPassword } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import styles from './ResetPassword.module.scss';
import Form from '../../Common/Form/Form';
import ResetPasswordForm from './ResetPasswordForm/ResetPasswordForm';
import UnauthenticatedRoute from '../../../_functional/UnauthenticatedRoute';
import FormAlert from '../../Common/FormAlert/FormAlert';

function ResetPassword() {
  const navigate = useNavigate();
  const [formAlert, setFormAlert] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  async function onSubmit(data) {
    setIsSubmitting(true);
    try {
      await confirmResetPassword({
        username: data.email,
        confirmationCode: data.verificationCode,
        newPassword: data.newPassword,
      });
      navigate('/account/signIn');
    } catch {
      setIsSubmitting(false);
      setFormAlert({
        severity: 'error',
        title: 'Could not complete password reset!',
        message:
          'Something went wrong when requesting password reset. Please contact the administrator for further support.',
      });
    }
  }

  return (
    <div className={styles.resetPassword}>
      <h1>Create new password</h1>
      <p className={styles.description}>
        Reset the password using the form below. The verification code should have been sent to you when you requested
        password reset.
      </p>
      <Form onSubmit={(data) => onSubmit(data)}>
        <ResetPasswordForm />

        <div className={styles.formControls}>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting} fullWidth>
            <span>Change Password</span>
          </LoadingButton>
        </div>
        {formAlert && <FormAlert alert={formAlert} />}
      </Form>
    </div>
  );
}

export default UnauthenticatedRoute(ResetPassword);
